import authService from '../services/authService';
import { navigatorUiLoggerFor } from './logger';

export const navigatorUiLogger = navigatorUiLoggerFor()({
  loggerUrl: 'https://bo9sq8lez4.execute-api.us-east-1.amazonaws.com/prod/v1/log',
  stage: 'prod',
  region: 'us-east-1',
  token: authService.currentIdToken,
});
